// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table.UsersTable {
  --border: 1px solid rgba(0, 0, 0, 0.15);
  min-height: calc(100vh - var(--header-height));
}
.Table.UsersTable table {
  --sp-table-header-bg: var(--bs-secondary-subtle);
  background-color: #fff;
  border-width: 1px 0;
}
.Table.UsersTable table .TableRow {
  display: flex;
  align-items: stretch;
  width: 100%;
}
.Table.UsersTable table .TableRow + .TableRow,
.Table.UsersTable table .TableRow + .Table-End {
  border-top: var(--border);
}
.Table.UsersTable table .TableRow.selected {
  background-color: var(--vt-selected-shading);
}
.Table.UsersTable table .TableRow.TableRow-Header {
  border-bottom: var(--border);
}
.Table.UsersTable table .TableRow.TableRow-Header .TableCell-Content {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 800;
}
.Table.UsersTable table .TableRow .TableCell {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 0;
}
.Table.UsersTable table .TableRow .TableCell + .TableCell {
  border-left: var(--border);
}
.Table.UsersTable table .TableRow .TableCell .TableCell-Content {
  padding: 0.35rem;
  align-content: center;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
  min-width: 0;
  width: 100%;
}
.Table.UsersTable table .TableRow .TableCell.SELECT {
  flex: 0 0 2.2rem;
}
.Table.UsersTable table .TableRow .TableCell.USERNAME {
  flex: 1;
}
.Table.UsersTable table .TableRow .TableCell.NAME {
  flex: 1;
}
.Table.UsersTable table .TableRow .TableCell.EMAIL {
  flex: 1.5;
}
.Table.UsersTable table .TableRow .TableCell.ROLE {
  flex: 0.5;
}
.Table.UsersTable table .TableRow .TableCell.LAST-LOGIN {
  flex: 1;
}
.Table.UsersTable table .TableRow .TableCell.AIRPORTS {
  flex: 1;
}
.Table.UsersTable table .TableRow .TableCell.AIRPORTS .TableCell-Content {
  overflow: visible;
  text-overflow: unset;
}
.Table.UsersTable table .TableRow .TableCell.EMPLOYEE-ID {
  flex: 0.5;
}
.Table.UsersTable table .TableRow .TableCell.ACTIVE {
  flex: 0 0 8rem;
  overflow: visible;
}
.Table.UsersTable table .TableRow .TableCell.ACTIVE .TableCell-Content {
  overflow: visible;
}
.Table.UsersTable table .TableRow .TableCell.RESET-PW {
  flex: 0 0 6rem;
}
.Table.UsersTable table .TableRow .TableCell.USERNAME .TableCell-Content, .Table.UsersTable table .TableRow .TableCell.NAME .TableCell-Content, .Table.UsersTable table .TableRow .TableCell.EMAIL .TableCell-Content, .Table.UsersTable table .TableRow .TableCell.AIRPORTS .TableCell-Content, .Table.UsersTable table .TableRow .TableCell.EMPLOYEE-ID .TableCell-Content {
  white-space: normal;
  word-break: break-word;
}
.Table.UsersTable .Table-Controls {
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Users/UsersTable/styles.scss"],"names":[],"mappings":"AAEA;EACE,uCAAA;EACA,8CAAA;AADF;AAGE;EACE,gDAAA;EACA,sBAAA;EACA,mBAAA;AADJ;AAGI;EACE,aAAA;EACA,oBAAA;EACA,WAAA;AADN;AAGM;;EAEE,yBAAA;AADR;AAIM;EACE,4CAAA;AAFR;AAKM;EACE,4BAAA;AAHR;AAIQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAFV;AAMM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AAJR;AAMQ;EACE,0BAAA;AAJV;AAOQ;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AALV;AAQQ;EACE,gBAAA;AANV;AASQ;EACE,OAAA;AAPV;AAUQ;EACE,OAAA;AARV;AAWQ;EACE,SAAA;AATV;AAYQ;EACE,SAAA;AAVV;AAaQ;EACE,OAAA;AAXV;AAcQ;EACE,OAAA;AAZV;AAcU;EACE,iBAAA;EACA,oBAAA;AAZZ;AAgBQ;EACE,SAAA;AAdV;AAiBQ;EACE,cAAA;EACA,iBAAA;AAfV;AAiBU;EACE,iBAAA;AAfZ;AAmBQ;EACE,cAAA;AAjBV;AAyBU;EACE,mBAAA;EACA,sBAAA;AAvBZ;AA8BE;EACE,oBAAA;AA5BJ","sourcesContent":["@import '../../../globals.scss';\n\n.Table.UsersTable {\n  --border: 1px solid rgba(0, 0, 0, 0.15);\n  min-height: calc(100vh - var(--header-height));\n\n  table {\n    --sp-table-header-bg: var(--bs-secondary-subtle);\n    background-color: #fff;\n    border-width: 1px 0;\n\n    .TableRow {\n      display: flex;\n      align-items: stretch;\n      width: 100%;\n\n      + .TableRow,\n      + .Table-End {\n        border-top: var(--border);\n      }\n\n      &.selected {\n        background-color: var(--vt-selected-shading);\n      }\n\n      &.TableRow-Header {\n        border-bottom: var(--border);\n        .TableCell-Content {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          font-weight: 800;\n        }\n      }\n\n      .TableCell {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-align: center;\n        min-width: 0;\n\n        + .TableCell {\n          border-left: var(--border);\n        }\n\n        .TableCell-Content {\n          padding: 0.35rem;\n          align-content: center;\n          text-align: center;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          font-weight: 700;\n          min-width: 0;\n          width: 100%;\n        }\n\n        &.SELECT {\n          flex: 0 0 2.2rem;\n        }\n\n        &.USERNAME {\n          flex: 1;\n        }\n\n        &.NAME {\n          flex: 1;\n        }\n\n        &.EMAIL {\n          flex: 1.5;\n        }\n\n        &.ROLE {\n          flex: 0.5;\n        }\n\n        &.LAST-LOGIN {\n          flex: 1;\n        }\n\n        &.AIRPORTS {\n          flex: 1;\n\n          .TableCell-Content {\n            overflow: visible;\n            text-overflow: unset;\n          }\n        }\n\n        &.EMPLOYEE-ID {\n          flex: 0.5;\n        }\n\n        &.ACTIVE {\n          flex: 0 0 8rem;\n          overflow: visible;\n\n          .TableCell-Content {\n            overflow: visible;\n          }\n        }\n\n        &.RESET-PW {\n          flex: 0 0 6rem;\n        }\n\n        &.USERNAME,\n        &.NAME,\n        &.EMAIL,\n        &.AIRPORTS,\n        &.EMPLOYEE-ID {\n          .TableCell-Content {\n            white-space: normal;\n            word-break: break-word;\n          }\n        }\n      }\n    }\n  }\n\n  .Table-Controls {\n    margin-right: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
